export enum CourseCreationType {
  Edit = "edit",
  Create = "create",
}
